<template>
  <div id="content" v-if="!loading">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <section>
      <form>
        <div class="inner">
          <p class="paging">
            <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
          </p>
          <p class="buttons" v-if="$_deleteActionAllowed">
            <a class="btn btn_action btn_delete" :title="'Smazat' | translate"
               @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
          </p>
          <h1 v-if="entity.name">{{ entity.name }}</h1>
        </div>

        <tabs-wrapper>
          <tabs-list>
            <tabs-list-item
                v-for="item in tabs"
                :key="item.key"
                :item="item"
                :activate-class="getActiveTabClass(item.key)"
                @activate-tab="activateTab">
            </tabs-list-item>
          </tabs-list>
          <tabs-content v-show="isActiveTab('detail')">
            <locality-detail-form
                :entity="entity"
                :showDefaultLocalityCheckbox="!showDefaultLocalityTab"
                :operatorOptions="operatorOptions"
                :isEditable="isEditable"
                ref="localitydetailformref"
            ></locality-detail-form>
            <section class="buttons" v-if="isEditable">
              <p>
                <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
                </router-link>
                <input type="submit" :value="'Uložit' | translate"
                       :class="['btn']"
                       @click.prevent.stop="submitForm()">
              </p>
            </section>
          </tabs-content>
          <tabs-content v-show="isActiveTab('default-localities')">
            <default-localities
                :entity="entity"
                :isEditable="isEditable"
                :operatorOptions="operatorOptions"
                @reload-entity="reloadEntity()"
                ref="localityipprefixesref"
            ></default-localities>
          </tabs-content>
          <tabs-content v-show="isActiveTab('related-localities')">
            <related-localities
                :entity="entity"
                :isEditable="isEditable"
                :operatorOptions="operatorOptions"
                @reload-entity="reloadEntity()"
                ref="localityipprefixesref"
            ></related-localities>
          </tabs-content>
          <tabs-content v-show="isActiveTab('ip-prefixes')">
            <ip-prefixes-list
                :ipPrefixes="entity.ip_prefixes"
                :localityId="entity.id"
                :localityIdOperator="entity.id_operator"
                :isEditable="isEditable"
                :operatorOptions="operatorOptions"
                @reload-entity="reloadEntity()"
                ref="localityipprefixesref"
            ></ip-prefixes-list>
          </tabs-content>
          <tabs-content v-show="isActiveTab('content-sources')">
            <content-sources-list
                :locality="entity"
                :operatorOptions="operatorOptions"
                :isEditable="isEditable"
                @reload-entity="reloadEntity()"
                ref="localitycontentsourcesref"
            ></content-sources-list>
          </tabs-content>
        </tabs-wrapper>
      </form>
    </section>
  </div>
</template>

<script>
import LocalityDetailForm from "@/components/views/localities/locality/LocalityDetailForm";
import RelatedLocalities from "@/components/views/localities/locality/RelatedLocalities";
import DefaultLocalities from "./locality/DefaultLocalities.vue";
import IpPrefixesList from "@/components/views/localities/locality/IpPrefixesList";
import ContentSourcesList from "@/components/views/localities/locality/ContentSourcesList";
import detailActions from "@/components/mixins/detail-actions";
import localities from "./mixins/localities";
import TabsWrapper from "@/components/common/tabs/TabsWrapper";
import TabsList from "@/components/common/tabs/TabsList";
import TabsListItem from "@/components/common/tabs/TabsListItem";
import TabsContent from "@/components/common/tabs/TabsContent";

export default {
  name: "LocalitiesDetail",
  components: {
    LocalityDetailForm,
    RelatedLocalities,
    DefaultLocalities,
    IpPrefixesList,
    ContentSourcesList,
    TabsContent,
    TabsListItem,
    TabsList,
    TabsWrapper
  },
  mixins: [detailActions, localities],
  created(LocalityService, OperatorService) {
    this.entityService = LocalityService;
    this.operatorService = OperatorService
    this.getOperators(true, true);
    this.createdInit();
    if(this.getActiveTab() == null){
      this.activateTab('detail');
    }
  },
  computed: {
    tabs() {
     let tabs = [
        {key: 'detail', text: this.$gettext('Vlastnosti')},
        {key: 'related-localities', text: this.$gettext('Související lokality')},
        {key: 'ip-prefixes', text: this.$gettext('Prefixy')},
        {key: 'content-sources', text: this.$gettext('Zdroje obsahu')}
      ];
      if(this.showDefaultLocalityTab){
        tabs.splice(1,0, {key: 'default-localities', text: this.$gettext('Výchozí lokality')});
      }

      return tabs;
    },
    isEditable(){
      return this.$_updateActionAllowed;
    },
    showDefaultLocalityTab(){
      return !this.entity.id_operator && this.$_updateActionAllowedAllOrOwnAndGlobal;
    }
  },
  beforeDestroy() {
    this.activateTab('detail')
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/localities/LocalitiesDetail.vue